###
A helper for triggering dataLayer events with an API similar
shopify-gtm-instrumentor but for non-Shopify products.
###
import ShopifyGtmInstrumentor from 'shopify-gtm-instrumentor'
import { makeImgixUrl } from '@bkwld/cloak/services/helpers'
import { twoDecimals } from 'library/services/helpers'

# Subclass shopify-gtm-instrumentor so it works with products, not variants
export default class extends ShopifyGtmInstrumentor

	# Overriding this so it works with Craft products as well as those that
	# have had grassdoorVariants mixed in from
	# library/mixins/grassdoor-supported-product.coffee
	makeFlatVariant: (product) ->
		primaryVariant = product.variants?[0]

		# Product level info
		productId: product.id
		productTitle: product.title
		productVariantTitle: product.title
		productType: product.productCategory?[0]?.title
		productVendor: "Papa & Barkley"
		productUrl: (productUrl = "#{process.env.URL}/#{product.uri}")

		# Variant level data
		sku: primaryVariant?.sku || null
		price: do ->
			if price = primaryVariant?.price?.amount
			then twoDecimals price
			else null
		compareAtPrice: do ->
			if price = primaryVariant?.compareAtPrice?.amount
			then twoDecimals price
			else null
		variantId: primaryVariant?.id || product.id
		variantTitle: primaryVariant?.title || product.title
		variantImage: makeImgixUrl product.image?[0]?.path
		variantUrl: primaryVariant?.url || productUrl
